
//helper small component
const StatusBadge = ({ status }) =>{
    let className  = 'px-3 py-1 text-xs font-medium rounded-full'
    switch(status){
        case 'Paid':
            className += ' bg-green-100 text-green-800'
            break;
        case 'Pending':
            className += ' bg-yellow-100 text-yellow-800'
            break;
        case 'Failed':
        case 'Refunded':
            className += ' bg-red-100 text-red-800'
            break;
        default:
            className += ' bg-gray-100 text-gray-800'
    }
    console.log(status);
    return <span className={className}>{status}</span>
}

const UserHistory = ({history = []}) =>{
    //1 handle empty state
    if(!history || history.length == 0){
        return (
            <div className="text-center text-gray-500 p-8">
                The user don't have any subscription history
            </div>
        );
    }

    //`2 summary calculation 
    const totalPaid = history.reduce((total,plan)=> total + (plan.cost || 0),0);
    const totalPlans = history.length;

    const memberSince = new Date(history[0].startDate).toLocaleDateString('en-GB');
    return (
        <div className="flex flex-col gap-6">
            {/* summary  */}
            <div>
                <h3 className="text-lg font-medium text-gray-800 mb-3">Summary</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    {/* total amount  */}
                    <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                        <span className="text-sm text-gray-600 block">Total Lifetime value</span>
                        <span className="text-2xl font-bold text-gray-900">₹{totalPaid.toLocaleString()}</span>
                    </div>
                    {/* total Plan */}
                    <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                        <span className="text-sm text-gray-600 block">Total Plans</span>
                        <span className="text-2xl font-bold text-gray-900">{totalPlans}</span>
                    </div>
                    {/* member since  */}
                    <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                        <span className="text-sm text-gray-600 block">Member Since</span>
                        <span className="text-2xl font-bold text-gray-900">{memberSince}</span>
                    </div>

                </div>
            </div>

            {/* detialed summary table  */}
            <h3 className="text-lg font-medium text-gray-800 mb-3">Detailed History</h3>
            <div className="overflow-x-auto rounded-lg border border-gray-200">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider ">Start Date</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider ">End Date</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider ">Amount</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider ">Status</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {/* sort most recent  */}
                        {[...history].reverse().map((plan,index)=>(
                            <tr key={plan._id}>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                                    {new Date(plan.startDate).toLocaleDateString('en-GB')}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                                    {new Date(plan.endDate).toLocaleDateString('en-GB')}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                                    {plan.cost.toLocaleString()}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm">
                                    <StatusBadge status={plan.paymentStatus}/>
                                </td>
                            </tr>
                        )) 
                        }                   
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default UserHistory;